var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelop16EMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C1.44772 13 1 12.5523 1 12V3H15V12C15 12.5523 14.5523 13 14 13H2ZM2.5 4.5H13.5V5.47056L7.99144 8.43671L2.5 5.69098V4.5ZM2.5 6.80902V11.5H13.5V6.60631L8.00851 9.56327L2.5 6.80902Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop16EMail);
export default __webpack_public_path__ + "static/media/envelop_16e_mail.57ecdf99be8a1e94d381aa475c756199.svg";
export { ForwardRef as ReactComponent };